import { ImageFit, ImageFrame } from '../../listing-image/listing-image.model';

export interface InputFile {
    id?: any;
    sequenceNo?: number;
    publicSequenceNo?: number | null; //image pool: null/undefined = private, 0 = main image of the public listing
    frame?: ImageFrame | null; //listing frame (relative), null/undefined = whole image centered
    fit?: ImageFit;
    file?: File;
    link?: string;
    preview?: string | ArrayBuffer | null;
}

export function isPublicFile(f: InputFile): boolean {
    return f.publicSequenceNo != null;
}

//public files ordered by their public position
export function publicFiles(files: InputFile[]): InputFile[] {
    return files.filter(isPublicFile).sort((a, b) => a.publicSequenceNo! - b.publicSequenceNo!);
}

//renumbers the public positions to 0..n-1 (keeps the order), unchanged files keep their object
export function normalizePublicSequence(files: InputFile[]): InputFile[] {
    const ordered = publicFiles(files);
    return files.map(f => {
        const position = ordered.indexOf(f);
        return position === -1 || f.publicSequenceNo === position ? f : { ...f, publicSequenceNo: position };
    });
}
